module.exports = __webpack_public_path__ + "media/cortina/guia-der-alapared-1a4adef0.png";